// extracted by mini-css-extract-plugin
export default {"title":"contacts_title__+zqXC","text":"contacts_text__plt0x","mr100":"contacts_mr100__lBSVo","mr50":"contacts_mr50__Qzfr4"};